<template>
  <div class="flex flex-col p-7.5 h-56.25 gap-7.5" style="background:rgba(110,117,141,0.1);">
    <div class="flex justify-between items-center">
      <img
          :src="require(`@/assets/images/slide_1/service_icons/${image}.svg`)"
          class="icon h-12.5"
          alt=""
      />
      <p class="service-name font-medium text-white uppercase fz-20" style="line-height: 2.25rem">
        {{ title }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "service",
  props:['title', 'image']
}
</script>

<style scoped>

</style>